<template>
  <item-state v-if="onGoingAndStarted" :waitingMode="waitingMode" :alarmStatus="alarmStatusLast" />
</template>
<script lang="ts">
import { AloMission, GLIDER_MODE } from '@/models/alo/AloMission'
import ItemState from '@/components/shared/ItemState.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbFleet, isAloDbFleetFree } from '@/models/alodb/AloDbFleet'

@Component({
  name: 'FleetState',
  props: {
    fleet: AloDbFleet,
  },
  components: { ItemState },
})
export default class FleetState extends Vue {
  fleet!: AloDbFleet

  get onGoingAndStarted() {
    return (
      this.$store.myGetters.isFleetOnGoing(this.fleet) && (this.fleet.param.start_date || isAloDbFleetFree(this.fleet))
    )
  }

  get waitingMode() {
    const waitingModes = this.missions.map(m => m.gliderWaitingMode)
    if (waitingModes.indexOf(GLIDER_MODE.GLIDER_MODE_WAITING_FOR_RESUME) > -1)
      return GLIDER_MODE.GLIDER_MODE_WAITING_FOR_RESUME
    if (waitingModes.indexOf(GLIDER_MODE.GLIDER_MODE_WAITING_FOR_GO) > -1) return GLIDER_MODE.GLIDER_MODE_WAITING_FOR_GO
    if (waitingModes.indexOf(GLIDER_MODE.GLIDER_MODE_DISCONNECTED) > -1) return GLIDER_MODE.GLIDER_MODE_DISCONNECTED
    return GLIDER_MODE.GLIDER_MODE_DISCONNECTED
  }

  get missions() {
    return (
      this.fleet?.activeMissionIds
        ?.map(id => this.$store.myGetters.missionsById[id])
        ?.filter(m => !!m && m.misActifOn) ?? []
    )
  }

  get alarmStatusLast() {
    return Array.from(new Set(this.missions.flatMap(m => m.alarmStatusLast)))
  }
}
</script>
